import { useMutation } from '@tanstack/react-query'
import { UpdateCreativeParams, updateCreative } from 'supabase/creatives'
import { queryClient } from 'utils'

export const useUpdateCreative = (
  onSuccess: (updated: any) => any
) => {
  const mutation = useMutation({
    mutationFn: (creative: UpdateCreativeParams) => {
      return updateCreative(creative)
    },
    onSuccess: (data: any, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['creatives'],
      })
      queryClient.invalidateQueries({
        queryKey: ['creative', variables.id],
      })

      onSuccess(data)
    },
  })

  return mutation
}